import { MotionConfig } from 'framer-motion';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { PrivacyPage } from './brief/PrivacyPage.js';
import { QuestionnairePage } from './client/QuestionnairePage.js';
import { Spinner } from './components/ui.js';

// The consultant dashboard is its own chunk: clients never download it.
const AdminApp = lazy(() => import('./admin/AdminApp.js').then((m) => ({ default: m.AdminApp })));
const BriefPage = lazy(() => import('./brief/BriefPage.js').then((m) => ({ default: m.BriefPage })));

const fallback = (
  <div className="flex min-h-[100svh] items-center justify-center">
    <Spinner />
  </div>
);

export function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </MotionConfig>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/q/:token" element={<QuestionnairePage />} />
      <Route
        path="/brief/:token"
        element={
          <Suspense fallback={fallback}>
            <BriefPage />
          </Suspense>
        }
      />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={fallback}>
            <AdminApp />
          </Suspense>
        }
      />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
